import type { WSModel } from "@/services/socket/ws.service";
import { WSCommands } from "@/constants/ws";
import { socketEmitter } from "@/services/socket/socket-emitter";

export class TripSocketHandler implements WSModel {
  handleWSData(data: any) {
    if (!data.command) {
      return;
    }

    switch (data.command) {
      case WSCommands.trip:
        this.handleTrip(data);
        break;
      case WSCommands.tripMonitor:
        this.handleMonitorItem(data);
        break;
      case WSCommands.tripMonitorRoute:
        this.handleRoute(data);
        break;
      case WSCommands.tripTruck:
        this.handleTruck(data);
        break;
      case WSCommands.order:
        this.handleOrder(data);
        break;
    }
  }

  private handleTrip(data: any) {
    if (data?.tripId) {
      socketEmitter.emit("trip:updated", { tripId: data.tripId });
    }
  }

  private handleMonitorItem(data: any) {
    if (data?.trip) {
      socketEmitter.emit("trip:monitor-item", { trip: data.trip });
    }
  }

  private handleRoute(data: any) {
    if (data?.route) {
      socketEmitter.emit("trip:route-updated", { route: data.route });
    }
  }

  private handleTruck(data: any) {
    if (data?.truck) {
      socketEmitter.emit("trip:truck-updated", { truck: data.truck });
    }
  }

  private handleOrder(data: any) {
    if (data?.order) {
      socketEmitter.emit("order:updated", { order: data.order });
    }
  }
}
